import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { CONSTANT } from "src/app/constant";
import { OBAttempt } from "src/app/models/models";

export interface ObAttemptField extends OBAttempt {
	lastSavedAction: string;
}

@Component({
	selector: "app-ob-container-single-selection",
	templateUrl: "./ob-container-single-selection.component.html",
	styleUrls: ["./ob-container-single-selection.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class ObContainerSingleSelectionComponent implements OnInit {
	@Input() obFormGroup!: UntypedFormGroup;
	@Input() OB!: any;
	@Input() showButtons: boolean = true;
	@Input() readOnly = false;

	attempt: Array<number> = [];
	// updatedAttempt: Array<number> = [];
	// lastSavedAction: Array<string> = [];
	// isPredefined: Array<boolean> = [];
	obValue: ObAttemptField[] = [];
	obTitle!: string;
	obTitleIndex!: number;
	OB_LAST_ACTION = CONSTANT.OB_LAST_ACTION;

	@Output() emitOBContainerValue: EventEmitter<any> = new EventEmitter<any>();

	constructor() {}

	ngOnInit(): void {
		this.intObBox(this.obFormGroup.value);

		this.obFormGroup.valueChanges.subscribe((a) => {
			console.log("this.obFormGroup", this.obFormGroup);
			this.intObBox(a);
		});
	}

	intObBox(a: UntypedFormGroup) {
		let index = 0;
		for (const value of Object.values(a)) {
			const val = value as OBAttempt;

			if (val.showButton == false) {
				this.showButtons = false;
			}

			this.obValue[index] = {
				...val,
				lastSavedAction: this.obValue[index]?.lastSavedAction ?? val.lastAction,
			};

			index++;
		}
	}

	getOb(index: number): any {
		const title = this.OB.title;
		const value = this.obFormGroup.get(`${title}${index + 1}`)?.value as ObAttemptField;

		if (!value) return false;

		return {
			...value,
			lastSavedAction: value.lastAction,
		};
	}

	getTitle(title: string): string {
		return `${title}`;
	}

	removeAttempt(title: string, index: number): void {
		if (this.readOnly) return;
		if (this.obValue[index].preDefined) {
			if (this.obValue[index].currentCount != 0) {
				let remove = this.obValue[index].currentCount;

				remove--;

				this.obValue[index].currentCount = remove;

				this.obValue[index].lastSavedAction = this.obValue[index].lastAction;
				this.obValue[index].lastAction = this.OB_LAST_ACTION.REMOVED;

				const obName = `${title}${index + 1}`;

				this.emitOBContainerValue.emit([this.obFormGroup.get(obName), obName, false, this.obValue[index]]);
			}
		} else {
			this.removeAttemptOB(title, index);
		}
	}

	removeAttemptOB(title: string, index: number): void {
		if (this.obValue[index].currentCount == 0) {
			let count = this.obValue[index].currentCount;
			let totalCount = this.obValue[index].totalCount;

			if (count === this.obValue[index].totalCount) {
				totalCount++;
			}

			count++;

			this.obValue[index].currentCount = count;
			this.obValue[index].totalCount = totalCount;

			this.obValue[index].lastSavedAction = this.obValue[index].lastAction;
			this.obValue[index].lastAction = this.OB_LAST_ACTION.ADDED;
		}
		if (this.obValue[index].currentCount != 0) {
			let remove = this.obValue[index].currentCount;

			remove--;

			this.obValue[index].currentCount = remove;

			this.obValue[index].lastSavedAction = this.obValue[index].lastAction;
			this.obValue[index].lastAction = this.OB_LAST_ACTION.REMOVED;

			const obName = `${title}${index + 1}`;

			this.emitOBContainerValue.emit([this.obFormGroup.get(obName), obName, false, this.obValue[index]]);
		}
	}

	addAttempt(title: string, index: number): void {
		if (this.readOnly) return;
		if (this.obValue[index].totalCount < CONSTANT.MAX_OB_ATTEMPT_LIMIT) {
			let count = this.obValue[index].currentCount;
			let totalCount = this.obValue[index].totalCount;

			totalCount++;
			count++;

			this.obValue[index].currentCount = count;
			this.obValue[index].totalCount = totalCount;

			this.obValue[index].lastSavedAction = this.obValue[index].lastAction;
			this.obValue[index].lastAction = this.OB_LAST_ACTION.ADDED;

			const obName = `${title}${index + 1}`;
			this.emitOBContainerValue.emit([this.obFormGroup.get(obName), obName, true, this.obValue[index]]);
		}
	}

	disableRemove(index: number): boolean {
		return (
			(this.obValue[index].currentCount === 0 && this.obValue[index].preDefined) ||
			(this.obValue[index].currentCount === 0 &&
				!this.obValue[index].preDefined &&
				this.obValue[index].lastAction !== "-")
		);
	}

	disableAdd(index: number): boolean {
		return (
			this.obValue[index].totalCount == CONSTANT.MAX_OB_ATTEMPT_LIMIT ||
			(this.obValue[index].preDefined &&
				!(
					this.obValue[index].lastAction === "-" ||
					this.obValue[index].lastAction === this.OB_LAST_ACTION.CREATE ||
					this.obValue[index].lastAction === this.OB_LAST_ACTION.EDIT
				) &&
				this.obValue[index].totalCount == this.obValue[index].currentCount)
		);
	}

	get maneuver() {
		return this.obFormGroup.get("maneuver")!;
	}
}
